import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trade-agreements-skeleton',
  templateUrl: './trade-agreements-skeleton.component.html',
  styleUrls: ['./trade-agreements-skeleton.component.scss'],
})
export class TradeAgreementsSkeletonComponent implements OnInit {
  readonly dataSource: number[] = Array(7).fill(0); // Crea un array de 7 elementos
  readonly displayedColumns: string[] = [
    'Fecha de creación',
    'Estado',
    'Categoría',
    'Acuerdos/Pendientes',
    'Notas del vendedor',
    'Mis notas',
  ];

  constructor() {}

  ngOnInit() {}
}
